module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label-tag', {
    attrs: {
      "tagArray": [_vm.$t('general_list'), _vm.$t('story_mode'), _vm.$t('vocabulary_mode'), _vm.$t('conversation_mode')],
      "previous": _vm.isVoices
    },
    on: {
      "updatedScene": _vm.updatedScene,
      "updatedMode": _vm.updatedMode,
      "previousPage": function($event) {
        _vm.isVoices = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-5",
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.modeId === 0 && !_vm.isVoices) ? _c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('time_used')))]), _vm._v(" "), _c('th', [_vm._v("(" + _vm._s(_vm.$t('story_mode')) + ")" + _vm._s(_vm.$t('usage_time')))]), _vm._v(" "), _c('th', [_vm._v("(" + _vm._s(_vm.$t('vocabulary_mode')) + ")" + _vm._s(_vm.$t('usage_time')))]), _vm._v(" "), _c('th', [_vm._v("(" + _vm._s(_vm.$t('conversation_mode')) + ")" + _vm._s(_vm.$t('usage_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('total_usage_time')))])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid"
    }
  }, _vm._l((_vm.summaryList), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.studentNo) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.realName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.usedCount) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.plotSpendTime) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.vocabSpendTime) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.dialogSpendTime) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [(_vm.modeId === 1 && !_vm.isVoices) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('last_update_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('scene')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('score')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('detail')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('study_time')))])]) : _vm._e(), _vm._v(" "), (_vm.modeId === 2 && !_vm.isVoices) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('last_update_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('scene')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('result')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('words_found')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('study_time')))])]) : _vm._e(), _vm._v(" "), (_vm.modeId === 3 && !_vm.isVoices) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('last_update_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('scene')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('result')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('score')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('detail')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('study_time')))])]) : _vm._e(), _vm._v(" "), (_vm.isVoices) ? _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('student_id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('dialogue')) + "\n            "), _vm._m(0)]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('score')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('views')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('play')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('download')))])]) : _vm._e()]), _vm._v(" "), (!_vm.isVoices) ? _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid"
    }
  }, [_vm._l((_vm.modeList), function(item) {
    return (_vm.modeId === 1) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.studentNo) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.userName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(0, 11)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(11, 200)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.situationName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.voiceScore) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "link-tag pointer",
      on: {
        "click": function($event) {
          return _vm.goVoice(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('detail')) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.modeList), function(item) {
    return (_vm.modeId === 2) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.studentNo) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.userName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(0, 11)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(11, 200)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.situationName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.situationName === 'Practice' ? '-----' : (item.isSuccess ? _vm.$t('pass') : _vm.$t('fail'))) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.foundNum) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.modeList), function(item) {
    return (_vm.modeId === 3) ? _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.studentNo) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.userName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(0, 11)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.createTime.slice(11, 200)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.situationName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.isSuccess ? _vm.$t('pass') : _vm.$t('fail')) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.voiceScore) + "\n          ")]), _vm._v(" "), (_vm.modeId !== 2) ? _c('td', {
      staticClass: "pointer link-tag",
      on: {
        "click": function($event) {
          return _vm.goVoice(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('detail')) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isVoices) ? _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "border-bottom": "1px #cccccc solid"
    }
  }, _vm._l((_vm.voiceData), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(index === 0 ? _vm.studentInfo.studentNo : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(index === 0 ? _vm.studentInfo.userName : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "min-width": "40%"
      }
    }, _vm._l((item.wordScores), function(el, index) {
      return _c('span', {
        class: {
          'good': item.score > 75, 'normal': item.score < 75 && item.score > 65, 'bad': item.score < 65
        },
        staticStyle: {
          "margin-left": ".2rem"
        }
      }, [_vm._v("\n              " + _vm._s(el.text) + "\n            ")])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(item.score)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.listenedCount))]), _vm._v(" "), _c('td', {
      staticClass: "pointer link-tag",
      on: {
        "click": function($event) {
          return _vm.playAudio(item.voiceUrl)
        }
      }
    }, [_c('a', [_vm._v("\n              " + _vm._s(_vm.$t('play')) + "\n            ")])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "link-tag",
      attrs: {
        "download": "",
        "target": "_blank",
        "href": item.voiceUrl
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t('download')) + "\n            ")])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.modeId === 0 && _vm.pageCount > 1) ? _c('pagination', {
    attrs: {
      "current": _vm.pageIndex,
      "total": _vm.pageCount
    },
    on: {
      "page": _vm.getSummaryList
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modeId !== 0 && _vm.modePageCount > 1) ? _c('pagination', {
    attrs: {
      "current": _vm.modePageIndex,
      "total": _vm.modePageCount
    },
    on: {
      "page": _vm.getModeList
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "audio"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.voiceUrl,
      "type": "audio/ogg"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ml-3 my-auto"
  }, [_c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("很棒")]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-warning mx-2"
  }, [_vm._v("尚可")]), _vm._v(" "), _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("待加強")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-633cf1af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/Record.vue
// module id = 791
// module chunks = 3